import _ from 'lodash';
import { instance } from 'services';

export const setAuthorizationHeader = (token: null | string = null): void => {
  const path = ['defaults', 'headers', 'common', 'Authorization'];
  if (token) _.set(instance, path, `Bearer ${token}`);
  else _.unset(instance, path);
};
